import { Sparkles } from 'lucide-react'

/** Placeholder for features that are temporarily disabled. */
export default function ComingSoon({ title, note }: { title: string; note?: string }) {
  return (
    <div className="mx-auto max-w-xl">
      <div className="rounded-2xl border border-dashed border-gray-200 bg-white p-12 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#EC5B2C]/10">
          <Sparkles className="h-7 w-7 text-[#EC5B2C]" />
        </div>
        <h1 className="text-xl font-bold text-gray-900">{title}</h1>
        <p className="mt-1 text-sm text-gray-500">{note || 'Coming soon — we’re still building this.'}</p>
      </div>
    </div>
  )
}
